import { RootState } from '../../Presentation/store';

export const selectKeywordState = (state: RootState) => state.keyword;
export const selectKeywordLoading = (state: RootState) => state.keyword.loading;
export const selectKeywordResult = (state: RootState) => state.keyword.result;
export const selectKeywordError = (state: RootState) => state.keyword.error;
